import { useCallback } from "react";

import { DROPDOWN_ORG_ID } from "@/components/fastshift/src/state/constants";
import { CustomerDomainOrg } from "@/components/fastshift/src/state/types";
import { useBxpWebStargateClient } from "@/libraries/bxp-web-stargate-client/src";

import {
    setSelectedDomainOrg,
    getL1Assessments,
    getMigrationPlanTotals,
    getInstances
} from "../../../../state/actions";
import {
    useFastshiftDispatch,
    useFastshiftSelector
} from "../../../../state/hook";

export const useOrg = () => {
    const dispatch = useFastshiftDispatch();
    const stargateClient = useBxpWebStargateClient();

    const domainOrg = useFastshiftSelector((state) => state.selectedDomainOrg);

    const setDomainOrg = useCallback(
        (org: CustomerDomainOrg) => {
            dispatch(setSelectedDomainOrg(org));

            const isValidCloudOrg =
                org &&
                !Object.values(DROPDOWN_ORG_ID).includes(
                    org.orgId as DROPDOWN_ORG_ID
                );

            if (isValidCloudOrg) {
                dispatch(
                    getL1Assessments({ stargateClient, orgId: org.orgId })
                );
                dispatch(
                    getMigrationPlanTotals({ stargateClient, orgId: org.orgId })
                );
                dispatch(getInstances({ stargateClient, orgId: org.orgId }));
            }
        },
        [dispatch, stargateClient]
    );

    return { domainOrg, setDomainOrg };
};
